var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { ToolbarWithBackButton } from '../common/Toolbar';
import { Body } from '../root/PageRouter';
import { Grid, Tile, TileHeader, TileComment } from '../common/Tile';
import { getEmail } from './helpers';
import Loading from '../common/Loading';
import { startCase, snakeCase } from 'lodash/fp';
import { useRouter } from '../../context/router-context';
import { List, ListItem } from '@bootstraplabs/bsw-common-react';
import { useAdminUserListQuery } from '../../__generated__/graphql';
function Toolbar() {
    return _jsx(ToolbarWithBackButton, { children: "Manage Users" }, void 0);
}
export default function AdminUserList() {
    // Router
    var goForwardClick = useRouter().goForwardClick;
    // GraphQL query
    var _a = useAdminUserListQuery(), data = _a.data, loading = _a.loading;
    var users = data && data.users;
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(Toolbar, {}, void 0),
                _jsx(Loading, {}, void 0)] }, void 0));
    }
    if (!users) {
        throw new Error('Users query failed');
    }
    return (_jsxs(_Fragment, { children: [_jsx(Toolbar, {}, void 0),
            _jsx(Body, { children: _jsx(Grid, { children: _jsxs(Tile, __assign({ span: 12 }, { children: [_jsxs(TileHeader, { children: ["Users (", users.length, ") and Access"] }, void 0),
                            _jsx(TileComment, { children: "Manage users, roles and access to the platform." }, void 0),
                            users.map(function (user) { return (_jsxs(Fragment, { children: [_jsx(TileHeader, __assign({ onClick: goForwardClick(user.id) }, { children: getEmail(user) }), void 0),
                                    _jsx(List, { children: _jsx(ListItem, { primary: user.roles
                                                .map(function (u) { return startCase(snakeCase(u)); })
                                                .join(', '), onClick: goForwardClick(user.id) }, void 0) }, void 0)] }, user.id)); })] }), void 0) }, void 0) }, void 0)] }, void 0));
}
//# sourceMappingURL=AdminUserList.js.map